import {ROUTES} from "./app.routes";
import {BrowserModule} from "@angular/platform-browser";
import {NgModule} from "@angular/core";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {AppComponent} from "./app.component";
import {StateService} from "./service/state";
import {
    MatButtonModule,
    MatCardModule, MatCheckboxModule, MatChipsModule, MatDialogModule,
    MatFormFieldModule, MatGridListModule, MatIconModule, MatInputModule, MatListModule, MatMenuModule,
    MatProgressBarModule,
    MatProgressSpinnerModule, MatRadioModule,
    MatSelectModule, MatSidenavModule,
    MatTabsModule, MatToolbarModule
} from "@angular/material";
import {NoPreloading, PreloadAllModules, RouterModule} from "@angular/router";
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {ApiService} from "./service/api";
import {LoadingService} from "./service/loading";
import {HomeComponent} from "./pages/home/home";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {LoginDialogComponent} from "./components/login/login.dialog";
import {LocalForageModule} from "ngx-localforage";
import {AdminGuard} from "./components/guards/AdminGuard";
import {HomeArticleDetail} from "./pages/article/detail";
import {NgPipesModule} from "ngx-pipes";
import {CartService} from "./service/cart";
import {SWIPER_CONFIG, SwiperConfigInterface, SwiperModule} from "ngx-swiper-wrapper";
import {CartOverviewComponent} from "./pages/cart/cart";
import {ContactComponent} from "./pages/contact/contact";
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {RegisterComponent} from "./pages/register/register";
import {ArticleService} from "./service/article";
import {OdersComponent} from "./pages/oders/oders.component";
import {OrdersComponent} from "./pages/orders/orders.component";
import {CheckoutComponent} from './pages/checkout/checkout.component';
import {HttpClient, HttpClientModule} from "@angular/common/http";
import {AlertModule} from "ngx-bootstrap";
import {CommonModule} from "@angular/common";
import {CartNotificationComponent} from './components/cart-notification/cart-notification.component';
import {RegisterCodeComponent} from "./pages/register/code";
import {ShipmentInfoComponent} from "./pages/shipment/info.component";
import {FormularComponent} from './components/login/formular/formular.component';
import {AddressComponent} from "./components/checkout/address/address.component";
import {PaymentComponent} from "./components/checkout/payment/payment.component";
import {OverviewComponent} from './components/checkout/overview/overview.component';
import {DetailComponent} from './pages/orders/detail/detail.component';
import {PayPalDialog} from "./components/checkout/dialog/paypal/paypal.component";
import {AdvanceDialog} from "./components/checkout/dialog/advance/advance.component";
import {PurchaseComponent} from "app/pages/orders/detail/purchase.component";
import {PickupDialog} from "./components/checkout/dialog/pickup/pickup.component";
import {Angulartics2Module} from "angulartics2";
import {Angulartics2Piwik} from "angulartics2/piwik";
import {ArticleResolver} from "./pages/article/resolver.service";
import {CdkTableModule} from "@angular/cdk/table";
import {MediaMatcher} from "@angular/cdk/layout";

const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
    direction: 'horizontal',
    slidesPerView: 'auto'
};

/**
 * Root Module
 * App bootstrap here, add your component (Page) to var [declarations] for load.
 */
@NgModule({
    imports: [
        Angulartics2Module.forRoot([
            Angulartics2Piwik
        ]),
        CommonModule,
        // Angular Imports
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        // Extra Plugin Imports
        NgxDatatableModule,
        // If you using lazy loading, var [preloadingStrategy] can change to PreloadAllModules or NoPreloading.
        RouterModule.forRoot(ROUTES, {preloadingStrategy: PreloadAllModules}),
        MatTabsModule,
        MatCardModule,
        MatSelectModule,
        MatChipsModule,
        MatDialogModule,
        MatIconModule,
        MatToolbarModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatListModule,
        MatGridListModule,
        MatRadioModule,
        MatCheckboxModule,
        MatSidenavModule,
        MatMenuModule,
        AlertModule.forRoot(),
        HttpClientModule,
        LocalForageModule.forRoot(),
        SwiperModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        BrowserAnimationsModule,
        NgPipesModule
    ],
    exports: [
        TranslateModule
    ],
    providers: [
        AdminGuard,
        // Global service (Global state)
        StateService,
        CartService,
        LoadingService,
        ApiService,
        ArticleService,
        ArticleResolver,
        MediaMatcher,
        {
            provide: SWIPER_CONFIG,
            useValue: DEFAULT_SWIPER_CONFIG
        }
    ],

    declarations: [
        // Page
        HomeComponent,
        CartOverviewComponent,
        HomeArticleDetail,
        AppComponent,
        LoginDialogComponent,
        ContactComponent,
        RegisterComponent,
        RegisterCodeComponent,
        ShipmentInfoComponent,
        OrdersComponent,
        CheckoutComponent,
        CartNotificationComponent,
        FormularComponent,
        AddressComponent,
        PaymentComponent,
        DetailComponent,
        OverviewComponent,
        PayPalDialog,
        AdvanceDialog,
        PickupDialog,
        PurchaseComponent
    ],

    entryComponents: [
        HomeComponent,
        CartOverviewComponent,
        HomeArticleDetail,
        LoginDialogComponent,
        ContactComponent,
        RegisterComponent,
        RegisterCodeComponent,
        ShipmentInfoComponent,
        CartNotificationComponent,
        FormularComponent,
        AddressComponent,
        PaymentComponent,
        DetailComponent,
        OverviewComponent,
        PayPalDialog,
        AdvanceDialog,
        PickupDialog,
        PurchaseComponent
    ],
    bootstrap: [
        AppComponent
    ]
})
export class AppModule {
}

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/');
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts